import { createStore } from "vuex";
import { getField, updateField } from "vuex-map-fields";
import clientConfig from "../config/foresters-financial";

// -----------------------------------------------------

const state = {
  appVersion: process.env.APP_VERSION || '0',
  debugMode: true,
  isLoading: false,
  lastUpdated: clientConfig.lastUpdated,
  
  activeTabName: "tab1",
  activeTab: 1,
  lastActiveTab: 1,

  acceptedDisclaimer: false,
  enabledIncomePlan: false,

  // activePanelName: "step1",
  // activePanel: 1,
  // lastActivePanel: 1,

  analyticsPageNames: [
    '',
    'Landing page',
    'About you',
    'Investments',
    'Results',
    'Next steps',
    'Disclaimer',
    'Editable assumptions'
  ],

  data: clientConfig.params,

  typeOfInvestor: '',
  typeOfBond: '',
  grossIncome: 120000,
  requiredFuneralFund: clientConfig.defaults.requiredFuneralFund,
  targetSavingDuration: null,

  investmentRisk: clientConfig.defaults.investmentRisk,
  startingDeposit: null,
  investmentTerm: clientConfig.defaults.investmentTerm,

  makeRegularContributions: true,
  extraContributions: null,
  extraContributionFrequency: '',
  extraContributionsRateOfIncrease: clientConfig.defaults.extraContributionsRateOfIncrease,

  incomePlanStart: '11',
  incomePlanLumpSumWithdrawal: 0,
  incomePlanLumpSumWithdrawalYear: '11',
  incomePlanContributions: 0,
  incomePlanContributionFrequency: '',

  wageInflation: clientConfig.defaults.wageInflation,
  priceInflation: clientConfig.defaults.priceInflation,
  assetFee: clientConfig.defaults.assetFee,
  rbaCashRate: clientConfig.defaults.rbaCashRate,
  investmentReturns: clientConfig.defaults.investmentReturns,
  userDefinedInvestment: '',
  customInvestmentReturnRate: null,

};
// -----------------------------------------------------

const frequencyPerYear = (frequency) => {
  switch (frequency) {
    case "year":
      return 1;
    case "month":
      return 1 / 12;
    case "quarter":
      return 1 / 4;
    case "fortnight":
      return 12 / 313;
    // case "week":
    //   return 6 / 313;
    default:
      return 1;
  }
};

// eslint-disable-next-line no-unused-vars
const safeFieldValue = (fieldToCheck) => {
  return ((typeof fieldToCheck !== 'undefined') && !isNaN(parseFloat(fieldToCheck)) ? fieldToCheck : 0)
}

// -----------------------------------------------------

const mutations = {
  setActiveTab(state, value) {
    if (state.activeTab < 6) {
      state.lastActiveTab = state.activeTab;
    }
    state.activeTab = value;
    state.activeTabName = "tab" + value;
  },

  // setActivePanel(state, value) {
  //   state.lastActivePanel = state.activePanel;
  //   state.activePanel = value;
  //   state.activePanelName = "step" + value;
  // },

  setLoading(state, value) {
    state.isLoading = value;
  },

  setAcceptDisclaimer(state, value) {
    state.acceptedDisclaimer = value;
  },

  setEnableIncomePlan(state, value) {
    state.enabledIncomePlan = value;
  },

  updateField,

  resetModeller(state) {
    state.isLoading = false,

    state.activeTabName = "tab1";
    state.activeTab = 1;
    state.lastActiveTab = 1;

    state.acceptedDisclaimer = false;
    state.enabledIncomePlan = false;

    // state.activePanelName = "step1";
    // state.activePanel = 1;
    // state.lastActivePanel = 1;

    state.data = clientConfig.params;

    state.typeOfInvestor = '';
    state.typeOfBond = '';
    state.grossIncome = null;
    state.requiredFuneralFund = clientConfig.defaults.requiredFuneralFund;
    state.targetSavingDuration = null;

    state.investmentRisk = clientConfig.defaults.investmentRisk;
    state.startingDeposit = null;
    state.investmentTerm = clientConfig.defaults.investmentTerm;

    state.makeRegularContributions = true;
    state.extraContributions = null;
    state.extraContributionFrequency = '';
    state.extraContributionsRateOfIncrease = clientConfig.defaults.extraContributionsRateOfIncrease;

    state.incomePlanStart = '';
    state.incomePlanLumpSumWithdrawal = 0;
    state.incomePlanLumpSumWithdrawalYear = '';
    state.incomePlanContributions = 0;
    state.incomePlanContributionFrequency = '';

    state.wageInflation = clientConfig.defaults.wageInflation;
    state.priceInflation = clientConfig.defaults.priceInflation;
    state.assetFee = clientConfig.defaults.assetFee;
    state.rbaCashRate = clientConfig.defaults.rbaCashRate;
    state.investmentReturns = clientConfig.defaults.investmentReturns;
    state.userDefinedInvestment = '';
    state.customInvestmentReturnRate = null;
  }
};

// -----------------------------------------------------

const getters = {
  appVersion: state => {
    return state.appVersion;
  },
  
  debugMode: state => {
    return state.debugMode;
  },

  isLoading: state => {
    return state.isLoading;
  },

  analyticsPageNames: state => {
    return state.analyticsPageNames;
  },

  activeTab: state => {
    return state.activeTab;
  },

  lastActiveTab: state => {
    return state.lastActiveTab;
  },

  activeTabName: state => {
    return state.activeTabName;
  },

  acceptedDisclaimer: state => {
    return state.acceptedDisclaimer;
  },

  enabledIncomePlan: state => {
    return state.enabledIncomePlan;
  },

  // activePanel: state => {
  //   return state.activePanel;
  // },

  // lastActivePanel: state => {
  //   return state.lastActivePanel;
  // },

  // activePanelName: state => {
  //   return state.activePanelName;
  // },

  data: (state) => {
    return state.data;
  },

  typeOfInvestor: state => {
    return state.typeOfInvestor;
  },

  typeOfBond: state => {
    return state.typeOfBond;
  },

  grossIncome: state => {
    return state.grossIncome;
  },

  requiredFuneralFund: state => {
    return state.requiredFuneralFund;
  },

  targetSavingDuration: state => {
    return state.targetSavingDuration;
  },

  investmentRisk: state => {
    return state.investmentRisk;
  },

  startingDeposit: state => {
    return state.startingDeposit;
  },

  selectedInvestmentReturnRate: state => {
    switch(state.investmentRisk) {
      case 1: // Low (RBA cash rate)
        return state.rbaCashRate;

      case 2: // Moderate (CPI + 2%)
        return state.priceInflation + state.investmentReturns[2];

      case 3: // Moderate to high (CPI + 3%)
        return state.priceInflation + state.investmentReturns[3];

      case 4: // High (CPI + 4%)
        return state.priceInflation + state.investmentReturns[4];

      case 5: // Custom Investment
        return state.customInvestmentReturnRate;

      default:
        return 0;
    }
  },

  userDefinedInvestmentReturnRate: state => {
    switch(state.userDefinedInvestment) {
      case 1: // Low (RBA cash rate)
        return state.rbaCashRate;

      case 2: // Moderate (CPI + 2%)
        return state.priceInflation + state.investmentReturns[2];

      case 3: // Moderate to high (CPI + 3%)
        return state.priceInflation + state.investmentReturns[3];

      case 4: // High (CPI + 4%)
        return state.priceInflation + state.investmentReturns[4];

      default:
        return 0;
    }
  },

  availableInvestmentOptions: state => {
    // if (state.typeOfBond === 3) { // Education
      // return [
      //   { value: 1, label: "Low" },
      //   { value: 2, label: "Moderate" },
      //   { value: 3, label: "Moderate to high" },
      //   // { value: 4, label: "High" }
      // ];
    // } else

    if (state.typeOfBond === 2) { // Funeral
      const values = [
        { value: 1, label: "Low" },
        { value: 2, label: "Moderate" },
        { value: 3, label: "Moderate to high" },
        // { value: 4, label: "High" } Spec - R05 contradicts R02b
      ];
      if (state.userDefinedInvestment !== '') {
        values.push({ value: 5, label: "Custom" });
      }
      return values;

    } else { // Investment
      const values = [
        { value: 2, label: "Moderate" },
        { value: 3, label: "Moderate to high" },
        { value: 4, label: "High" },
      ];
      if (state.userDefinedInvestment !== '') {
        values.push({ value: 5, label: "Custom" });
      }
      return values;
    }
  },

  startingDepositMinimum: state => {
    // if (state.typeOfBond === 3) { // Education
    //   return state.data.startingDeposit.educationMin;
    // } else 
    if (state.typeOfBond === 2) { // Funeral
      return state.data.startingDeposit.funeralMin;
    } else { // Investment
      return state.data.startingDeposit.investmentMin;
    }
  },
  
  startingDepositMaximum: state => {
    // if (state.typeOfBond === 3) { // Education
    //   return state.data.startingDeposit.educationMax;
    // } else 
    if (state.typeOfBond === 2) { // Funeral
      return state.data.startingDeposit.funeralMax;
    } else { // Investment
      return state.data.startingDeposit.investmentMax;
    }
  },

  extraContributionsMinimum: state => {
    // if (state.typeOfBond === 3) { // Education
    //   return state.data.extraContributions.educationMin;
    // } else 
    if (state.typeOfBond === 2) { // Funeral
      return state.data.extraContributions.funeralMin;
    } else { // Investment
      return state.data.extraContributions.investmentMin;
    }
  },
  
  extraContributionsMaximum: state => {
    // if (state.typeOfBond === 3) { // Education
    //   return state.data.extraContributions.educationMax;
    // } else 
    if (state.typeOfBond === 2) { // Funeral
      return state.data.extraContributions.funeralMax;
    } else { // Investment
      return state.data.extraContributions.investmentMax;
    }
  },

  investmentTerm: state => {
    return state.investmentTerm;
  },

  makeRegularContributions: state => {
    return state.makeRegularContributions;
  },

  extraContributions: state => {
    return state.extraContributions;
  },

  extraContributionFrequency: state => {
    return state.extraContributionFrequency;
  },

  extraContributionsRateOfIncrease: state => {
    return state.extraContributionsRateOfIncrease;
  },

  incomePlanStart: state => {
    return state.incomePlanStart;
  },

  incomePlanLumpSumWithdrawal: state => {
    return state.incomePlanLumpSumWithdrawal;
  },

  incomePlanLumpSumWithdrawalYear: state => {
    return state.incomePlanLumpSumWithdrawalYear;
  },

  incomePlanContributions: state => {
    return state.incomePlanContributions;
  },

  incomePlanContributionFrequency: state => {
    return state.incomePlanContributionFrequency;
  },

  wageInflation: state => {
    return state.wageInflation;
  },

  priceInflation: state => {
    return state.priceInflation;
  },

  assetFee: state => {
    return state.assetFee;
  },

  rbaCashRate: state => {
    return state.rbaCashRate;
  },

  investmentReturns: state => {
    return state.investmentReturns;
  },

  userDefinedInvestment: state => {
    return state.userDefinedInvestment;
  },

  extraContributionFrequencyFraction: (state) => {
    return frequencyPerYear(state.extraContributionFrequency);
  },

  incomePlanContributionFrequencyFraction: (state) => {
    return frequencyPerYear(state.incomePlanContributionFrequency);
  },

  welcomeFieldsValid: (state) => {
    return state.acceptedDisclaimer === true;
  },

  aboutFieldsValid: (state, getters) => {
    return (
      getters.welcomeFieldsValid && 
      state.typeOfInvestor !== null && state.typeOfInvestor !== '' &&
      state.typeOfBond !== null && state.typeOfBond !== '' &&
      ( (
          state.typeOfBond === 2 &&
          state.requiredFuneralFund !== null && state.requiredFuneralFund !== '' && 
          state.targetSavingDuration !== null && state.targetSavingDuration !== ''
        ) || 
        (
          state.typeOfBond === 1 && 
          state.grossIncome !== null && state.grossIncome !== ''
        )
      )
    );
  },

  investmentFieldsValid: (state, getters) => {
    return (
      getters.aboutFieldsValid &&
      state.investmentRisk !== null && state.investmentRisk !== '' &&
      state.makeRegularContributions !== null &&
      (
        state.makeRegularContributions === false || 
        (
          state.makeRegularContributions === true &&
          state.extraContributions !== null && state.extraContributions !== '' &&
          state.extraContributionFrequency !== null && state.extraContributionFrequency !== ''
        )
      ) &&
      ( state.typeOfBond === 2 || 
        (
          state.typeOfBond === 1 && 
          state.investmentTerm !== null && state.investmentTerm !== '' &&
          state.startingDeposit !== null && state.startingDeposit !== ''
        )
      )
    );
  },

  resultsFieldsValid: (state, getters) => {
    return (
      getters.investmentFieldsValid &&
      state.investmentRisk !== null && state.investmentRisk !== '' &&
      state.startingDeposit !== null && state.startingDeposit !== '' &&
      ( (
          state.typeOfBond === 2 &&
          state.requiredFuneralFund !== null && state.requiredFuneralFund !== '' && 
          state.targetSavingDuration !== null && state.targetSavingDuration !== '' 
        ) || 
        (
          state.typeOfBond === 1 && 
          state.grossIncome !== null && state.grossIncome !== '' &&
          state.investmentTerm !== null && state.investmentTerm !== '' &&
          state.extraContributionsRateOfIncrease !== null && state.extraContributionsRateOfIncrease !== ''
        )
      ) &&
      ( state.enabledIncomePlan === false || getters.incomePlanFieldsValid )
    );
  },

  incomePlanFieldsValid: (state) => {
    return (
      state.enabledIncomePlan === true &&
      state.incomePlanContributionFrequency !== null && state.incomePlanContributionFrequency !== '' &&
      state.incomePlanContributions !== null && state.incomePlanContributions !== '' &&
      state.incomePlanStart !== null && state.incomePlanStart !== '' &&
      ( (
          state.incomePlanLumpSumWithdrawal !== null && state.incomePlanLumpSumWithdrawal !== '' &&
          state.incomePlanLumpSumWithdrawalYear !== null && state.incomePlanLumpSumWithdrawalYear !== ''
        ) ||
        (
          state.incomePlanLumpSumWithdrawal === null || state.incomePlanLumpSumWithdrawal === '' || state.incomePlanLumpSumWithdrawal === 0
        )
      )
    );
  },

  getField,
};

export default createStore({
  state,
  mutations,
  getters,
});
